<template>
  <div id="app">
    <v-app>
      <Loading />
      <div id="nav"></div>
      <router-view />
    </v-app>
  </div>
</template>
<script>
import Loading from "@/components/Common/Loading";
export default {
  components: {
    Loading
  }
};
</script>

<style>
html {
  background-color: #5d7894;
}
#app {
  background-color: white;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #5d7894;
}

#nav {
  /* padding: 30px; */
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
